import * as React from 'react'
import { motion } from 'framer-motion'
import { Box, SxProps } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

export interface ArrowSvgProps {
  transform: string
  direction?: 'in' | 'out'
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const CurvedBottomArrow360Svg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="126" height="52" viewBox="0 0 126 52" fill="none" style={{ overflow: 'visible' }}>
        <g id="livevalue_arrows">
          <motion.g id="line">
            <path
              d="M1 50V29.507C1 21.2227 7.716 14.507 16 14.507H114.247C117.977 14.507 121 11.4834 121 7.75362V1"
              stroke="#A4AAAE"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </motion.g>

          {direction === 'in' && (
            <g id="arrow_in_curved_side_arrow" transform="translate(11 0)">
              <path
                d="M102.795 6.79177L102.726 6.86704C102.406 7.25982 102.428 7.8398 102.795 8.20599C103.161 8.57217 103.741 8.59488 104.133 8.27435L104.209 8.20599L110.707 1.70737C111.098 1.31685 111.098 0.683681 110.707 0.293157C110.317 -0.0973673 109.684 -0.0973673 109.293 0.293157L102.795 6.79177Z"
                fill="#A4AAAE"
              />
              <path
                d="M115.795 8.20722L115.871 8.27627C116.264 8.59645 116.843 8.57327 117.209 8.20722C117.6 7.81669 117.6 7.18353 117.209 6.793L110.709 0.293007C110.319 -0.097517 109.686 -0.097518 109.295 0.293006C108.905 0.68353 108.905 1.3167 109.295 1.70722L115.795 8.20722Z"
                fill="#A4AAAE"
              />
            </g>
          )}

          {direction === 'out' && (
            <g id="arrow_out_curved_side_arrow" transform="translate(-6 0)">
              <path
                d="M14.7079 45.2085L14.7763 45.1332C15.0968 44.7404 15.0741 44.1604 14.7079 43.7943C14.3417 43.4281 13.7617 43.4054 13.369 43.7259L13.2937 43.7943L6.79507 50.2929C6.40455 50.6834 6.40455 51.3166 6.79507 51.7071C7.18559 52.0976 7.81876 52.0976 8.20928 51.7071L14.7079 45.2085Z"
                fill="#A4AAAE"
              />
              <path
                d="M1.70718 43.793L1.63123 43.724C1.23845 43.4038 0.659025 43.427 0.292971 43.793C-0.0975533 44.1835 -0.0975534 44.8167 0.292971 45.2072L6.79297 51.7072C7.18349 52.0978 7.81665 52.0978 8.20718 51.7072C8.5977 51.3167 8.5977 50.6835 8.20718 50.293L1.70718 43.793Z"
                fill="#A4AAAE"
              />
            </g>
          )}
        </g>
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.curvedBottomArrow360Animation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default CurvedBottomArrow360Svg
